import { render } from "./NavBar.vue?vue&type=template&id=a31e2a06&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=a31e2a06&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31e2a06"]])

export default __exports__